import { readableColor } from "polished";
/**
 * Get color from theme.colors
 */

export var getColor = function getColor(theme, color) {
  var _a;

  if (typeof color === "function") {
    return color(theme);
  }

  var colorToParse = (_a = theme.rawColors) === null || _a === void 0 ? void 0 : _a[color];
  return Array.isArray(colorToParse) ? "" : colorToParse;
};
export var getReadableColor = function getReadableColor(theme, color) {
  return readableColor(getColor(theme, color));
};
export var responsive = function responsive(breakpoints) {
  return [breakpoints.xs, breakpoints.sm, breakpoints.md, breakpoints.lg, breakpoints.xl, breakpoints.xxl];
};